/**
 * Compares two semantic version strings.
 * @returns true if version >= minVersion
 */
export const isVersionGreaterOrEqual = (
  version: string,
  minVersion: string
): boolean => {
  if (!version) return false;
  if (version === 'unknown') return false;

  const versionParts = version.split('.').map(Number);
  const minParts = minVersion.split('.').map(Number);
  const maxLength = Math.max(versionParts.length, minParts.length);

  for (let i = 0; i < maxLength; i += 1) {
    const v = versionParts[i] || 0;
    const m = minParts[i] || 0;
    if (v > m) return true;
    if (v < m) return false;
  }
  return true;
};
